import { appRouters, otherRouters } from '../../router/router'
import Util from '../../lib/util';
import Vue from 'vue';
import _ from 'lodash';
import { Store, Module, ActionContext } from 'vuex'
import Vuex from 'vuex';
import ajax from '../../lib/ajax'
import appconst from '../../lib/appconst'
import SignalRAspNetCoreHelper from '../../lib/SignalRAspNetCoreHelper'
import util from '../../lib/util';
Vue.use(Vuex);
interface AppState {
    cachePage: Array<any>;
    lang: string;
    isFullScreen: boolean;
    openedSubmenuArr: Array<any>;
    menuTheme: string;
    themeColor: string,
    pageOpenedList: Array<any>;
    currentPageName: string;
    currentPath: Array<any>;
    menuList: Array<any>;
    routers: Array<any>;
    tagsList: Array<any>;
    messageCount: number;
    dontCache: Array<any>;
    noticeList: Array<any>;
	noticeUnreadTotalCount:number
}
class AppModule implements Module<AppState, any>{
    namespaced = true;
    state = {
        cachePage: [],
        lang: '',
        isFullScreen: false,
        openedSubmenuArr: [],
        menuTheme: 'light',
        themeColor: '',
        pageOpenedList: [{
            meta: { title: 'Dashboard' },
            path: 'fdashboard/dashboard',
            name: 'dashboard'
        }],
        currentPageName: 'dashboard',
        currentPath: [
            {
                meta: { title: 'Dashboard' },
                path: 'fdashboard/dashboard',
                name: 'dashboard'
            }
        ],
        menuList: [],
        routers: [
            otherRouters,
            ...appRouters
        ],
        tagsList: [...otherRouters.children],
        messageCount: 0,
        dontCache: [],
        noticeList:[],
        noticeUnreadTotalCount:0
    };
    mutations = {
        logout(state: AppState) {
            localStorage.clear();
            sessionStorage.clear();
        },
        setTagsList(state: AppState, list: Array<any>) {
            state.tagsList.push(...list);
        },
        updateMenulist(state: AppState) {
            let menuList: Array<Router> = [];
            var originAppRouters = appRouters;
            originAppRouters.forEach((item, index) => {
                if (!util.isNull(item.showInMenu) && item.showInMenu === false) {
                    return
                }
                if(item.children && item.children.length && item.children.length>0)
                {
                    let childrenArr = [];
                    item.children.forEach((child)=>
                    {
                        if (!util.isNull(child.showInMenu) && child.showInMenu === false) {
                            return ;
                        }
                        if(child.children && child.children.length && child.children.length>0)
                        {
                            let subchildrenArr = [];
                            subchildrenArr = child.children.filter(sub => {
                                if (!util.isNull(sub.showInMenu) && sub.showInMenu === false) {
                                    return null;
                                }
                                if (!util.isNull(sub.permission)) {
                                    if (Util.abp.auth.hasPermission(sub.permission)) {
                                        return sub;
                                    }
                                    return null;
                                }  
                                return sub;
                            });
                            child.children = (!Util.isNull(subchildrenArr) && subchildrenArr.length>0)?_.compact(subchildrenArr):null;
                        }
                        if ((!util.isNull(child.permission) && Util.abp.auth.hasPermission(child.permission)) || (child.children && child.children.length && child.children.length>0)) {
                            childrenArr.push(child);
                        }
                    })
                    item.children = (!Util.isNull(childrenArr) && childrenArr.length>0)? _.compact(childrenArr):null;

                    if ((!util.isNull(item.permission) && Util.abp.auth.hasPermission(item.permission)) || item.children) {
                        menuList.push(item);
                    }
                }
            });
            state.menuList = menuList;
        },
        changeMenuTheme(state: AppState, theme: string) {
            state.menuTheme = theme;
        },
        changeMainTheme(state: AppState, mainTheme: string) {
            state.themeColor = mainTheme;
        },
        addOpenSubmenu(state: AppState, name: any) {
            let hasThisName = false;
            let isEmpty = false;
            if (name.length === 0) {
                isEmpty = true;
            }
            if (state.openedSubmenuArr.indexOf(name) > -1) {
                hasThisName = true;
            }
            if (!hasThisName && !isEmpty) {
                state.openedSubmenuArr.push(name);
            }
        },
        closePage(state: AppState, name: any) {
            state.cachePage.forEach((item, index) => {
                if (item === name) {
                    state.cachePage.splice(index, 1);
                }
            });
        },
        initCachepage(state: AppState) {
            if (localStorage.cachePage) {
                state.cachePage = JSON.parse(localStorage.cachePage);
            }
        },
        removeTag(state: AppState, name: string) {
            state.pageOpenedList.map((item, index) => {
                if (item.name === name) {
                    state.pageOpenedList.splice(index, 1);
                }
            });
        },
        pageOpenedList(state: AppState, get: any) {
            let openedPage = state.pageOpenedList[get.index];
            if (get.argu) {
                openedPage.argu = get.argu;
            }
            if (get.query) {
                openedPage.query = get.query;
            }
            state.pageOpenedList.splice(get.index, 1, openedPage);
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        clearAllTags(state: AppState) {
            state.pageOpenedList.splice(1);
            state.cachePage.length = 0;
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        clearOtherTags(state: AppState, vm: Vue) {
            let currentName = vm.$route.name;
            let currentIndex = 0;
            state.pageOpenedList.forEach((item, index) => {
                if (item.name === currentName) {
                    currentIndex = index;
                }
            });
            if (currentIndex === 0) {
                state.pageOpenedList.splice(1);
            } else {
                state.pageOpenedList.splice(currentIndex + 1);
                state.pageOpenedList.splice(1, currentIndex - 1);
            }
            let newCachepage = state.cachePage.filter(item => {
                return item === currentName;
            });
            state.cachePage = newCachepage;
            localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        },
        setOpenedList(state: AppState) {
            state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [otherRouters.children[0]];
        },
        setCurrentPath(state: AppState, pathArr: Array<any>) {
            state.currentPath = pathArr;
        },
        setCurrentPageName(state: AppState, name: string) {
            state.currentPageName = name;
        },
        clearOpenedSubmenu(state: AppState) {
            state.openedSubmenuArr.length = 0;
        },
        increateTag(state: AppState, tagObj: any) {
            if (!Util.oneOf(tagObj.name, state.dontCache)) {
                state.cachePage.push(tagObj.name);
                localStorage.cachePage = JSON.stringify(state.cachePage);
            }
            state.pageOpenedList.push(tagObj);
        },
        processInfoToNotify(state: AppState, payload: any) {
            if(payload.data.length>1)
              state.noticeList.push(...payload.data);
            else
              state.noticeList.unshift(payload.data);
          },
         setNoticeUnreadTotalCount(state: AppState, payload: any) {
             state.noticeUnreadTotalCount = payload.data;
          },
         increaseNoticeUnreadTotalCount(state: AppState, payload: any) {
            state.noticeUnreadTotalCount += payload.data;
         },
         decreaseNoticeUnreadTotalCount(state: AppState, payload: any) {
            state.noticeUnreadTotalCount -= payload.data;
         },
    }
    actions = {
        async login(content: ActionContext<AppState, any>, payload: any) {
            try {
                let rep = await ajax.post("/api/TokenAuth/Authenticate", payload.data, {
                    headers: {
                        'EzS-UserName': payload.data.userNameOrEmailAddress
                    }
                });
                var tokenExpireDate = payload.data.rememberMe ? (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) : undefined;
                Util.abp.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
                Util.abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, Util.abp.appPath)
                SignalRAspNetCoreHelper.initSignalR();
                return rep.data.result.requireChangePassword;

            } catch (error) {
                console.log('error')
                Util.abp.utils.deleteCookie(Util.abp.multiTenancy.tenantIdCookieName, Util.abp.appPath);
                throw error;
            }
        },
    }
}
const appModule = new AppModule();
export default appModule;
